import { render, staticRenderFns } from "./dialogView.vue?vue&type=template&id=1bbd173a"
import script from "./dialogView.vue?vue&type=script&lang=ts"
export * from "./dialogView.vue?vue&type=script&lang=ts"
import style0 from "./dialogView.vue?vue&type=style&index=0&id=1bbd173a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports